import { useEffect, useState } from 'react';
import { fetchStandaloneTaskSupport } from '../../../../components/chartActions/credentialCapabilities';

// Shared so the toolbar and the per-row quick-actions menu compute the standalone
// task gate identically. When there is no EMR integration credential the answer is
// immediately true; otherwise probe capabilities and default to false until the
// probe resolves. Intentionally uncached so tests that swap the probe
// implementation (and real credential changes) are always reflected. The caller
// can skip the probe while task visibility flags already rule out the action.
const useStandaloneTaskSupport = (hasEmrIntegrationCredential, enabled = true) => {
  const [supported, setSupported] = useState(!hasEmrIntegrationCredential);

  useEffect(() => {
    let mounted = true;

    if (!hasEmrIntegrationCredential) {
      setSupported(true);
      return () => {
        mounted = false;
      };
    }

    setSupported(false);
    if (enabled) {
      fetchStandaloneTaskSupport().then((value) => {
        if (mounted) setSupported(value);
      });
    }

    return () => {
      mounted = false;
    };
  }, [hasEmrIntegrationCredential, enabled]);

  return supported;
};

export default useStandaloneTaskSupport;
